import Podcast from "./podcast";

export default Podcast;
